import KinvaDocDelete from './KinvaDocDelete'
export {KinvaDocDelete}
export default KinvaDocDelete
